const init = () => {
  var dated = (new Date()).getFullYear();
  var pressReleaseWidget = '.press-release-widget';
  var $selectedYear = jQuery('.selected-year');
  jQuery(pressReleaseWidget + '.' + dated).show();
  $selectedYear.val(dated);
  var hash = window.location.hash;
  if (hash !== '') {
    var year = hash.substr(1);
    $selectedYear.val(year);
    jQuery(pressReleaseWidget).hide();
    jQuery(pressReleaseWidget + '.' + year).show();
  }
  $selectedYear.on('change', function () {
    var year = $selectedYear.val();
    window.location.hash = '';
    var location = '';
    location = window.location.hash + year;
    window.location.hash = location;
    jQuery(pressReleaseWidget).hide();
    jQuery(pressReleaseWidget + '.' + year).show();
    jQuery('.ellipsis-wrapper').trigger('update.dot');
  });
  jQuery('.backward--link').click(function (e) {
    e.preventDefault();
    var referrer = document.referrer;
    if (referrer === '' || !(referrer.includes('www.freshworks.com'))) {
      window.location.href = '/newsroom/press-releases/';
    } else {
      window.history.back();
      jQuery('window').scrollTop();
    }
  });
};
export default { init };
